import React from 'react';
import { Box, Button, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useTranslation } from 'react-i18next';
import { RoutePathsValues } from '../../routePaths';
import { PaddedContainer } from '../PaddedContainer';
import { LocationReferrer } from '../../types/locationReferrer';

interface EditScreenLayoutProps {
    path: RoutePathsValues;
    buttonText?: string;
    icon?: React.ComponentType;
    isBackButtonShown?: boolean;
    isDesktopLarge?: boolean;
}

const EditScreenLayout: React.FC<EditScreenLayoutProps> = (
    { children, path, buttonText, icon = ArrowBackIcon, isBackButtonShown = true, isDesktopLarge }
) => {
    const Icon = icon;
    const { t } = useTranslation();
    const backText = buttonText || t('Back');
    const history = useHistory<LocationReferrer>();
    const { state = {} } = history.location;
    const { referrer } = state;
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    return (
        <PaddedContainer spacing={isDesktop ? 6 : 3}>
            <Grid item xs={12}>
                {isBackButtonShown
                    ? (
                        <Box mb={2} display="flex">
                            <Button
                                startIcon={<Icon />}
                                component={RouterLink}
                                to={referrer || path}
                                variant="contained"
                                color="primary"
                            >
                                {backText}
                            </Button>
                        </Box>
                    ): null}
            </Grid>
            <Grid item xs={12}>
                <Box display="flex" justifyContent="center">
                    <Grid item xs={12} md={8} lg={isDesktopLarge ? 8 : 6}>
                        {children}
                    </Grid>
                </Box>
            </Grid>
        </PaddedContainer>
    );
};

export default EditScreenLayout;
